import "./NavigationProductList.scss"
import {useEffect, useState} from "react";
import {useFiltre} from "../../utils/FiltreContext";
import {faSliders, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function NavigationProductList({setProductList, setActiveCategory, activeCategory, setFiltreClique}) {
    const [category, setCategory] = useState("");
    const [mainCategory, setMainCategory] = useState(sessionStorage.getItem('mainCategory') ? sessionStorage.getItem('mainCategory') : '');
    const [categoryFiltre, setCategoryFiltre] = useState(sessionStorage.getItem('categorieFiltre') ? sessionStorage.getItem('categorieFiltre') : '');
    const [bijouxMobileClique, setBijouxMobileClique] = useState(false);
    const [zenMobileClique, setZenMobileClique] = useState(false);
    const [bienEtreMobileClique, setBienEtreMobileClique] = useState(false);
    const {filtreOuvert, setFiltreOuvert, toggleFiltre} = useFiltre();

    useEffect(() => {
        if (category === "" || category === null) {
            return;
        }
        try {
            const fetchProductsFromOneCategory = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}products/category/${category}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });
                    const products = await response.json();
                    setProductList(products);
                    setActiveCategory(category);
                    setCategoryFiltre(category.replace(/"/g, ''))
                } catch (error) {
                    console.error("Erreur de connexion au serveur:", error);
                }
            };
            fetchProductsFromOneCategory();
        } catch (error) {
            console.log(error)
        }
    }, [category]);

    useEffect(() => {
        sessionStorage.setItem('categorieFiltre', categoryFiltre);
        sessionStorage.removeItem('filtrePrix');
    }, [categoryFiltre]);

    useEffect(() => {
        sessionStorage.setItem('mainCategory', mainCategory);
    }, [mainCategory]);

    const activeStyle = {
        fontWeight: "bold",
        color: "var(--primary-color, #5b7f50)"
    };

    const activeMobileStyle = {
        backgroundColor: "var(--primary-color, #5b7f50)",
        color: "#fff",
        borderColor: "var(--primary-color, #5b7f50)"
    };

    const inactiveMobileStyle = {
        backgroundColor: "#f8fafc",
        color: "#334155",
        borderColor: "#e2e8f0"
    };

    return (
        <>
            <div className={'main-div-navigation-products'}>
                <div className={'div-category-first-and-secondary'}>
                    <h3 style={mainCategory === "Bijoux" ? activeStyle : {}} onClick={() => {
                        setCategory("Bijoux");
                        setMainCategory("Bijoux")
                    }}>Bijoux et accessoires</h3>
                    <div className={"div-category-secondary"}>
                        <p onClick={() => {
                            setCategory("Bracelet");
                            sessionStorage.removeItem('pierresChoisies');
                            setMainCategory("Bijoux")
                        }} style={activeCategory === "Bracelet" ? activeStyle : {}}>Bracelet</p>
                        <p onClick={() => {
                            setCategory("Boucle Oreille");
                            sessionStorage.removeItem('pierresChoisies');
                            setMainCategory("Bijoux")
                        }} style={activeCategory === "Boucle Oreille" ? activeStyle : {}}>Boucle d'oreille</p>
                        <p onClick={() => {
                            setCategory("Accessoire");
                            setMainCategory("Bijoux")
                        }} style={activeCategory === "Accessoire" ? activeStyle : {}}>Accessoire</p>
                    </div>
                </div>
                <div className={'div-category-first-and-secondary'}>
                    <h3 style={mainCategory === "Zen" ? activeStyle : {}} onClick={() => {
                        setCategory("Zen");
                        setMainCategory("Zen")
                    }}>Ambiance zen</h3>
                    <div className={"div-category-secondary"}>
                        <p onClick={() => {
                            setCategory("Lampe sel");
                            setMainCategory("Zen")
                        }} style={activeCategory === "Lampe sel" ? activeStyle : {}}>Lampe de sel</p>
                        <p onClick={() => {
                            setCategory("Fontaine interieur");
                            setMainCategory("Zen")
                        }} style={activeCategory === "Fontaine interieur" ? activeStyle : {}}>Fontaine d'intérieur</p>
                        <p onClick={() => {
                            setCategory("Diffuseur");
                            setMainCategory("Zen")
                        }} style={activeCategory === "Diffuseur" ? activeStyle : {}}>Diffuseur d'ambiance</p>
                        <p onClick={() => {
                            setCategory("Statue");
                            setMainCategory("Zen")
                        }} style={activeCategory === "Statue" ? activeStyle : {}}>Statue</p>
                        <p onClick={() => {
                            setCategory("bruleur_parfum");
                            setMainCategory("Zen")
                        }} style={activeCategory === "bruleur_parfum" ? activeStyle : {}}>Brûleur parfum</p>
                    </div>
                </div>
                <div className={'div-category-first-and-secondary'}>
                    <h3 style={mainCategory === "Bien être" ? activeStyle : {}} onClick={() => {
                        setCategory("Bien être");
                        setMainCategory("Bien être")
                    }}>Bien être</h3>
                    <div className={"div-category-secondary"}>
                        <p onClick={() => {
                            setCategory("Purifier");
                            setMainCategory("Bien être")
                        }} style={activeCategory === "Purifier" ? activeStyle : {}}>Purifier / Assainir</p>
                        <p onClick={() => {
                            setCategory("Plateau recharge");
                            setMainCategory("Bien être")
                        }} style={activeCategory === "Plateau recharge" ? activeStyle : {}}>Plateau de recharge</p>
                        <p onClick={() => {
                            setCategory("Orgonite");
                            setMainCategory("Bien être")
                        }} style={activeCategory === "Orgonite" ? activeStyle : {}}>Orgonite</p>
                    </div>
                </div>
                <div className={"div-button-filtrer-trier"} onClick={() => setFiltreOuvert(true)}>
                    <FontAwesomeIcon icon={faSliders}/>
                    <p>Trier & Filtrer</p>
                </div>
            </div>

            <div className={"main-div-navigation-products-mobile"}>
                {!bijouxMobileClique && !zenMobileClique && !bienEtreMobileClique &&
                    <>
                        <div className={"div-main-category-mobile"}>
                            <h4 onClick={() => {
                                setBijouxMobileClique(true);
                                setCategory("Bijoux")
                            }}>Bijoux</h4>
                            <h4 onClick={() => {
                                setZenMobileClique(true);
                                setCategory("Zen")
                            }}>Ambiance Zen
                            </h4>
                            <h4 onClick={() => {
                                setBienEtreMobileClique(true);
                                setCategory("Bien etre")
                            }}>Bien être</h4>
                        </div>
                    </>
                }

                {bijouxMobileClique &&
                    <>
                        <div className={"div-header-secondary-category-mobile"}
                             onClick={() => {
                                 setBijouxMobileClique(false);
                                 setBienEtreMobileClique(false);
                                 setZenMobileClique(false);
                                 setCategory("Bijoux")
                             }}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                            <h4>Bijoux</h4>
                        </div>
                        <div className={"div-secondary-category-mobile"}>
                            <p style={category === "Bracelet" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Bracelet")}>Bracelet</p>
                            <p style={category === "Boucle Oreille" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Boucle Oreille")}>Boucle d'oreille</p>
                            <p style={category === "Accessoire" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Accessoire")}>Accessoire</p>
                        </div>
                    </>
                }
                {zenMobileClique &&
                    <>
                        <div className={"div-header-secondary-category-mobile"} onClick={() => {
                            setBijouxMobileClique(false);
                            setBienEtreMobileClique(false);
                            setZenMobileClique(false);
                            setCategory("Zen")
                        }}>
                            <FontAwesomeIcon icon={faArrowLeft}/>
                            <h4>Ambiance zen</h4>
                        </div>
                        <div className={"div-secondary-category-mobile"}>
                            <p style={category === "Lampe sel" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Lampe sel")}>Lampe de sel</p>
                            <p style={category === "Fontaine interieur" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Fontaine interieur")}>Fontaine d'intérieur</p>
                            <p style={category === "Diffuseur" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Diffuseur")}>Diffuseur d'ambiance</p>
                            <p style={category === "Statue" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Statue")}>Statue</p>
                        </div>
                    </>
                }
                {bienEtreMobileClique &&
                    <>
                        <div className={"div-header-secondary-category-mobile"} onClick={() => {
                            setBijouxMobileClique(false);
                            setBienEtreMobileClique(false);
                            setZenMobileClique(false)
                        }}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                            <h4>Bien être</h4>
                        </div>
                        <div className={"div-secondary-category-mobile"}>
                            <p style={category === "Purifier" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Purifier")}>Purifier / Assainir</p>
                            <p style={category === "Plateau recharge" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Plateau recharge")}>Plateau de recharge</p>
                            <p style={category === "Orgonite" ? activeMobileStyle : inactiveMobileStyle} 
                               onClick={() => setCategory("Orgonite")}>Orgonite</p>
                        </div>
                    </>
                }
                <div className={"div-button-filtrer-trier"} onClick={() => setFiltreOuvert(true)}>
                    <FontAwesomeIcon icon={faSliders}/>
                    <p>Trier & Filtrer</p>
                </div>
            </div>
        </>
    )
}

export default NavigationProductList;
